import React from "react";
import { observer } from "mobx-react";
import { Group, Text } from "@mantine/core";
import { IconProps } from "@tabler/icons-react";
import { TextWithInfo } from "../modals/textWithInfo";

interface ShowConfirmationsRowProps {
  icon: React.ComponentType<IconProps>;
  label: string;
  confirmations: number;
  infoLink?: string;
}

const makeConfirmationsString = (confirmations: number) => {
  if (confirmations === 0) return " confirmations";
  if (confirmations >= 12) return "more than 12";
  return `${confirmations}`;
};
const ShowConfirmationsRow: React.FC<ShowConfirmationsRowProps> = observer(
  ({ icon: Icon, label, confirmations, infoLink }) => {
    return (
      <tr>
        <td>
          <Group gap="xs">
            <Icon size="1rem" />
            <Text>{label}</Text>
            {/* <TextWithInfo
              textSize="md"
              text={label}
              infoLink={infoLink || "https://docs.megalithic.me"}
            /> */}
          </Group>
        </td>
        <td>
          <Text>{makeConfirmationsString(confirmations)}</Text>{" "}
          {/* Just the integer */}
        </td>
      </tr>
    );
  }
);

export default ShowConfirmationsRow;
